import { render, staticRenderFns } from "./invite-page.vue?vue&type=template&id=00d5359c&scoped=true&"
import script from "./invite-page.vue?vue&type=script&lang=js&"
export * from "./invite-page.vue?vue&type=script&lang=js&"
import style0 from "./invite-page.vue?vue&type=style&index=0&id=00d5359c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d5359c",
  null
  
)

export default component.exports